import { TimeClockFailurePolicyType } from "./TimeClockFailurePolicyType"
import { TimeClockScheduleModelType } from "./TimeClockScheduleModelType"
import { TimeClockValidationType } from "./TimeClockValidationType"

export type TimeClockSettings = {
  isEnabled: boolean
  validationTypes: TimeClockValidationType[]
  geofenceRadiusMeters: number
  latitude?: number | null
  longitude?: number | null
  failurePolicy: TimeClockFailurePolicyType
  scheduleModel: TimeClockScheduleModelType
  toleranceMinutes: number
  allowSharedTerminal: boolean
  duplicateWindowSeconds: number
  hasResolvedLocation: boolean
}

export const formatWorkedMinutes = (minutes: number): string => {
  const safeMinutes = Number.isFinite(minutes) && minutes > 0 ? Math.round(minutes) : 0

  const hours = Math.floor(safeMinutes / 60)

  return `${String(hours).padStart(2, "0")}:${String(safeMinutes % 60).padStart(2, "0")}`
}
